/**
 * Copyright 2025 Lumavec Group LLC
 *
 * All rights reserved. No part of this software may be used, copied, modified,
 * or distributed without explicit written permission. This software is provided
 * "as-is" without warranty of any kind, express or implied, including but not
 * limited to warranties of merchantability or fitness for a particular purpose.
 */

import { Badge } from '@/components/ui/badge';

interface DomainBadgeProps {
  domain: string;
}

const domainColors: Record<string, string> = {
  technical: 'bg-cyan-100 text-cyan-800 border-cyan-200',
  governance: 'bg-amber-100 text-amber-800 border-amber-200',
  operational: 'bg-emerald-100 text-emerald-800 border-emerald-200',
  strategy: 'bg-violet-100 text-violet-800 border-violet-200',
  systems: 'bg-orange-100 text-orange-800 border-orange-200',
  architecture: 'bg-indigo-100 text-indigo-800 border-indigo-200',
  design: 'bg-pink-100 text-pink-800 border-pink-200',
  capabilities: 'bg-teal-100 text-teal-800 border-teal-200',
  business: 'bg-lime-100 text-lime-800 border-lime-200',
  development: 'bg-sky-100 text-sky-800 border-sky-200',
};

export function DomainBadge({ domain }: DomainBadgeProps) {
  const colorClass = domainColors[domain.toLowerCase()] || 'bg-gray-100 text-gray-800 border-gray-200';
  
  // Capitalize first letter
  const label = domain.charAt(0).toUpperCase() + domain.slice(1);

  return (
    <Badge variant="outline" className={`text-xs ${colorClass}`}>
      {label}
    </Badge>
  );
}
